import React, { useEffect } from "react";
import { View } from "react-native";
import { useDispatch, useSelector } from "react-redux";

import * as actions from "state/modules/feedback/actions";
import { getFeedbackReview } from "state/modules/feedback/operations";
import { Loader } from "components";
import { styles } from "./styles";

export const FeedbackReviewQuestion = props => {
  const state = useSelector(state => state);
  const review = state.feedback.review;
  const isReviewReceived = state.feedback.isReviewReceived;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFeedbackReview());
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = e => {
    dispatch(actions.setFeedbackReview(e.target.value));
  };

  if (!review && !isReviewReceived) {
    return <Loader />;
  }

  return (
    <View style={styles.container}>
      <View style={styles.contentContainer}>
        <textarea
          rows="6"
          cols="40"
          onChange={e => handleChange(e)}
          placeholder={"You can edit the review..."}
        >
          {review}
        </textarea>
      </View>
    </View>
  );
};
